import { FC, SVGProps } from "react";

const NightIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="17" height="14" viewBox="0 0 17 14" fill="currentcolor" {...props}>
      <path
        d="M13.625 5.08333L12.4583 3.875L14.25 2.125L15.4167 3.29167L13.625 5.08333ZM0 13.3333V11.6667H16.6667V13.3333H0ZM7.5 2.5V0H9.16667V2.5H7.5ZM3.04167 5.04167L1.29167 3.25L2.45833 2.08333L4.25 3.875L3.04167 5.04167ZM4.52083 8.33333H12.1458C11.8264 7.58333 11.3264 6.97917 10.6458 6.52083C9.96528 6.0625 9.19444 5.83333 8.33333 5.83333C7.47222 5.83333 6.70139 6.0625 6.02083 6.52083C5.34028 6.97917 4.84028 7.58333 4.52083 8.33333ZM2.5 10C2.5 8.375 3.06597 6.99653 4.19792 5.86458C5.32986 4.73264 6.70833 4.16667 8.33333 4.16667C9.95833 4.16667 11.3368 4.73264 12.4688 5.86458C13.6007 6.99653 14.1667 8.375 14.1667 10H2.5Z"
      />
    </svg>
  );
};

export default NightIcon;
